import request from "@/api/request";

class Account {
  getBankAccount() {
    return request({
      url: "/api/bankaccount",
      method: "get"
    });
  }

  requestUpdate(data) {
    return request({
      url: "/api/bankaccount/request/update",
      method: "post",
      data: data
    });
  }
}

export default new Account();
